import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';
import './style.css';

const AddToCartIcon = (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5 2.5C5.49479 2.52604 5.80729 2.78646 5.9375 3.28125L5.97656 3.75H22.4219C22.8385 3.77604 23.1641 3.94531 23.3984 4.25781C23.6328 4.57031 23.7109 4.9349 23.6328 5.35156L21.5234 12.8516C21.3151 13.4245 20.9115 13.724 20.3125 13.75H7.92969L8.28125 15.625H20.3125C20.8854 15.6771 21.1979 15.9896 21.25 16.5625C21.1979 17.1354 20.8854 17.4479 20.3125 17.5H7.46094C6.99219 17.474 6.69271 17.2266 6.5625 16.7578L4.21875 4.375H2.1875C1.61458 4.32292 1.30208 4.01042 1.25 3.4375C1.30208 2.86458 1.61458 2.55208 2.1875 2.5H5ZM19.8438 11.875L21.6016 5.625H6.36719L7.57812 11.875H19.8438ZM6.25 20.625C6.27604 20.1042 6.45833 19.6615 6.79688 19.2969C7.16146 18.9583 7.60417 18.776 8.125 18.75C8.64583 18.776 9.08854 18.9583 9.45312 19.2969C9.79167 19.6615 9.97396 20.1042 10 20.625C9.97396 21.1458 9.79167 21.5885 9.45312 21.9531C9.08854 22.2917 8.64583 22.474 8.125 22.5C7.60417 22.474 7.16146 22.2917 6.79688 21.9531C6.45833 21.5885 6.27604 21.1458 6.25 20.625ZM21.25 20.625C21.224 21.1458 21.0417 21.5885 20.7031 21.9531C20.3385 22.2917 19.8958 22.474 19.375 22.5C18.8542 22.474 18.4115 22.2917 18.0469 21.9531C17.7083 21.5885 17.526 21.1458 17.5 20.625C17.526 20.1042 17.7083 19.6615 18.0469 19.2969C18.4115 18.9583 18.8542 18.776 19.375 18.75C19.8958 18.776 20.3385 18.9583 20.7031 19.2969C21.0417 19.6615 21.224 20.1042 21.25 20.625Z"
            fill="#206EFF"
        />
    </svg>
);

const Icon = function() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.5,15a3,3,0,0,0-1.9-2.78l1.87-7a1,1,0,0,0-.18-.87A1,1,0,0,0,20.5,4H6.8L6.47,2.74A1,1,0,0,0,5.5,2h-2V4H4.73l2.48,9.26a1,1,0,0,0,1,.74H18.5a1,1,0,0,1,0,2H5.5a1,1,0,0,0,0,2H6.68a3,3,0,1,0,5.64,0h2.36a3,3,0,1,0,5.82,1,2.94,2.94,0,0,0-.4-1.47A3,3,0,0,0,21.5,15Zm-3.91-3H9L7.34,6H19.2ZM9.5,20a1,1,0,1,1,1-1A1,1,0,0,1,9.5,20Zm8,0a1,1,0,1,1,1-1A1,1,0,0,1,17.5,20Z" fill="#6563ff"/></svg>
}

registerBlockType(metadata.name, {
    icon: AddToCartIcon,
    title: metadata.title,
    edit: Edit,
    icon: Icon
});
